import {useContext} from 'react'
import NotificationContext from '@/components/NotificationContext/NotificationContext'

const useNotification = () => useContext(NotificationContext)
export default useNotification
